import { TextField } from '@mui/material';
import Badge from '@mui/material/Badge';
import theme from '~/theme.js';
import IconButton from 'Components/Buttons/IconButton';
import InputNumber from 'Components/Forms/InputNumber';
import Table from 'Components/SimpleTable';
import React from 'react';
import icons from 'utils/ui/icons';
import { openMeterPhoto, renderVariation, renderYesNo } from '../renderUtils';
import { compactInputSx, photoBadgeSx } from '../reportStyles';

const commentsFieldStyle = {
    width: '100%',
    '& .MuiInputBase-input': { fontSize: '0.65rem' },
    '& .MuiFilledInput-root': { borderRadius: 0, paddingTop: '4px !important' },
    '& .MuiInputLabel-root': { transform: 'translate(12px, -15px) scale(0.75)' }
};

const ReadingsTable = props => {
    const { comments, loading, ratio, rows, systemOnline, systemValue, technicianValue } = props;
    const { onCommentsChange, onDiscardImage, onSystemChange, onTechnicianChange } = props;

    const columns = [
        { label: '#', dataKey: 'readingNumber' },
        { label: 'Date', dataKey: 'date' },
        { label: 'Ratio (Unit)', dataKey: 'ratio', transform: () => ratio },
        {
            label: 'System',
            dataKey: 'system',
            transform: row => {
                if (row.validated) {
                    return row.system;
                }
                return (
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, maxWidth: 140 }}>
                        {systemOnline ? (
                            <span>{systemValue}</span>
                        ) : (
                            <InputNumber disabled={loading} input={{ value: systemValue, onChange: e => onSystemChange(e.target.value) }} label="" margin="dense" meta={{}} sx={compactInputSx}/>
                        )}
                    </div>
                );
            }
        },
        {
            label: 'Technician',
            dataKey: 'technician',
            transform: row => {
                if (row.validated) {
                    return row.technician;
                }
                return (
                    <div style={{ maxWidth: 120 }}>
                        <InputNumber disabled={loading} input={{ value: technicianValue, onChange: e => onTechnicianChange(e.target.value) }} label="" margin="dense" meta={{}} sx={compactInputSx}/>
                    </div>
                );
            }
        },
        {
            label: 'Variation (%)',
            dataKey: 'variation',
            transform: row => renderVariation(row.variation, row.incomparable)
        },
        {
            label: 'Photo',
            dataKey: 'image',
            transform: row => {
                if (!row.image) {
                    if (!row.needsPhoto) {
                        return '';
                    }
                    return <span style={{ color: theme.palette.labelBadge.danger.color, fontSize: '0.65rem', fontWeight: 'bold' }}>Required</span>;
                }
                // A data-URL is an unsubmitted capture — still locally discardable.
                const pendingCapture = typeof row.image === 'string';
                return (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        <Badge badgeContent={row.readingNumber} sx={photoBadgeSx}>
                            <IconButton icon={['fas', 'image']} onClick={() => openMeterPhoto(row.image, row.readingNumber)} style={{ padding: 0 }} tooltip={`Meter Photo ${row.readingNumber}`}/>
                        </Badge>
                        {pendingCapture && (
                            <IconButton icon={icons.trash} onClick={onDiscardImage} style={{ padding: 0 }} tooltip="Discard photo"/>
                        )}
                    </span>
                );
            }
        },
        {
            label: 'Tech. Comments',
            dataKey: 'comments',
            transform: row => {
                if (row.validated) {
                    return row.comments;
                }
                return (
                    <TextField
                        minRows={1}
                        multiline
                        onChange={e => onCommentsChange(e.target.value)}
                        onClick={e => e.stopPropagation()}
                        size="small"
                        sx={commentsFieldStyle}
                        value={comments}
                        variant="filled"
                    />
                );
            }
        },
        { label: 'Live?', dataKey: 'online', transform: row => renderYesNo(row.online) }
    ];

    return (
        <Table columns={columns} headerHeight={28} loading={loading} rowHeight={28} rows={rows}/>
    );
};

export default ReadingsTable;
